export const VIEW_MODE_STORAGE_KEY = "tv-releases-view-mode";
export const DENSITY_STORAGE_KEY = "tv-releases-density";
export const BROWSE_PREFERENCES_VERSION_KEY = "tv-releases-browse-preferences-version";
export const BROWSE_PREFERENCES_VERSION = "2";
export const DEFAULT_DESKTOP_VIEW_MODE = "compact";
export const DEFAULT_DENSITY = "comfortable";

const VALID_VIEW_MODES = new Set(["grid", "compact", "list"]);
const VALID_DENSITIES = new Set(["comfortable", "compact"]);

export function isValidViewMode(value) {
  return VALID_VIEW_MODES.has(value);
}

export function isValidDensity(value) {
  return VALID_DENSITIES.has(value);
}

export function resolveBrowsePreferences({
  storedViewMode,
  storedDensity,
  storedVersion,
} = {}) {
  const hasCurrentVersion = storedVersion === BROWSE_PREFERENCES_VERSION;
  const hasExplicitLegacyMode = storedViewMode === "compact" || storedViewMode === "list";

  return {
    viewMode: isValidViewMode(storedViewMode) && (hasCurrentVersion || hasExplicitLegacyMode)
      ? storedViewMode
      : DEFAULT_DESKTOP_VIEW_MODE,
    density: isValidDensity(storedDensity) ? storedDensity : DEFAULT_DENSITY,
  };
}
